<div class="canvas-container">



  <section class="canvas-titlebar">
    <div class="titlebar-left">
      <h3>{{displayName}}</h3>
      <p *ngIf="isComponentDefinitionMode && componentDefinition?.activeVersion">
        Version: {{componentDefinition?.activeVersion}}
      </p>
      <p *ngIf="isComponentDefinitionMode && componentDefinition?.description">
        {{componentDefinition?.description}}
      </p>
      <p *ngIf="isComponentDefinitionMode && !componentDefinition?.description">
        Preview and customize the component visualization. This component can be used in various contexts throughout the application.
      </p>
      <p *ngIf="!isComponentDefinitionMode">
        Generate and customize how your data entities are visualized and interacted with in the AI assistant and database entity viewers
      </p>
    </div>
    <!--
      <button nz-button
              nz-tooltip
              [nzTooltipTitle]="'Test Button'"
              nzType="default"
              nzSize="small"
              class="canvas-title-button"
              (click)="onCanvasButtonClicked($event)">
        <i class="fa-regular fa-star"></i>&nbsp;Test
      </button>
    </div>
    <div class="titlebar-right">

      <button nz-button
              nz-tooltip
              [nzTooltipTitle]="'Test Button'"
              nzType="default"
              nzSize="small"
              class="canvas-title-button"
              (click)="onCanvasButtonClicked($event)">
        <i class="fa-regular fa-star"></i>&nbsp;Test
      </button>
    </div>
    -->
  </section>

    <!-- Content -->
    <div>
      <nz-collapse class="entity-visualization-collapse"
                   [nzBordered]="true"
                   [nzExpandIconPosition]="'right'">

        <nz-collapse-panel class="entity-visualization-collapse-panel"
                           nzActive="true"
                           nzGhost
                           [nzHeader]="nzCollapseHeader0">

          <ng-template #nzCollapseHeader0>
            <ng-container *ngTemplateOutlet="nzCollapseHeader;
                          context:{
                            title: isComponentDefinitionMode ? 'Component Visualization' : 'Entity Visualization',
                            description: isComponentDefinitionMode
                              ? 'Preview and customize the component visualization. This component can be used in various contexts throughout the application.'
                              : 'Create or select a component to visualize and interact with individual items of this entity. This will be used in the AI assistant and other detailed views.'
                          }"></ng-container>
          </ng-template>

          <!-- LOADING STATE -->
          <div class="loading-container" *ngIf="shouldShowLoadingState()">
            <nz-spin nzSize="large" [nzTip]="''">
            </nz-spin>
          </div>

          <!-- COMPONENT RENDERER -->
          <ng-container *ngIf="shouldShowComponent()">
            <div class="component-renderer-container">
            <div class="component-info-container" *ngIf="!isComponentDefinitionMode">
              <p *ngIf="!isComponentDefinitionMode && componentDefinition?.title">
                {{componentDefinition?.title}}
              </p>
              <p *ngIf="!isComponentDefinitionMode && componentDefinition?.activeVersion">
                Version: {{componentDefinition?.activeVersion}}
              </p>
            </div>
            <rappider-compiled-component-renderer *ngIf="getComponentDefinitionId()"
                                                  [componentType]="'flutter'"
                                                  [allowDisplayingInputData]="true"
                                                  [allowReRendering]="true"
                                                  [viewOnly]="false"
                                                  [componentDefinition]="{
                                                              bundleUrl: getEntityComponentBundleUrl(),
                                                              id: getComponentDefinitionId()
                                                              }"
                                                  [component]="{
                                                              id: 'entity_component_' + visualizationState.selectedModel?.id + '_' + getComponentDefinitionId() + '_' + uiState.componentKey
                                                              }"
                                                  [hideActionButtons]="true">
            </rappider-compiled-component-renderer>
            </div>
          </ng-container>

          <!-- EMPTY STATE -->
          <div class="no-component-state" *ngIf="shouldShowEmptyState()">
            <nz-empty
                      [nzNotFoundContent]="isComponentDefinitionMode
                        ? 'There is no component visualization available'
                        : 'There is no assigned visual element for this entity'">
            </nz-empty>
          </div>
        </nz-collapse-panel>

        <!-- Entity Fields Section - Hidden in component definition mode -->
        <nz-collapse-panel *ngIf="!isComponentDefinitionMode"
                           class="entity-visualization-collapse-panel entity-visualization-collapse-panel-entity-fields"
                           nzActive="true"
                           nzGhost
                           [nzHeader]="nzCollapseHeader2">

          <ng-template #nzCollapseHeader2>
            <ng-container *ngTemplateOutlet="nzCollapseHeader;
                          context:{
                            title: 'Entity Fields',
                            description: 'Manage and customize the fields of this entity. Add new fields, edit existing ones, and define their properties to ensure they meet your application\'s requirements.'
                          }"></ng-container>
          </ng-template>

          <rappider-new-project-model-field #newProjectModelFieldComponent
                                            [projectModel]="visualizationState.selectedModel!"
                                            (projectModelFieldDelete)="onProjectModelFieldDelete($event)"
                                            (projectModelFieldUpdate)="onProjectModelFieldUpdate($event)"
                                            (projectModelFieldCreate)="onProjectModelFieldCreate($event)"></rappider-new-project-model-field>

        </nz-collapse-panel>

      </nz-collapse>
    </div>

</div>

<ng-template #nzCollapseHeader
             let-title="title"
             let-description="description">
  <div class="collapse-header-container">
    <h4 class="p-2x title">{{title}}</h4>
    <p class="title-description">
      {{description}}
    </p>
  </div>
</ng-template>
